import { Status } from "../../../redux/interfaces/folder.types.ts";

export const validToUpload: any[] = [Status.PendingUpload, Status.Invalid];
